/*************************************************/
/* FACTS BLOCKS (mobile accordion)               */
/*************************************************/

// On mobile the facts-blocks component renders each block as an accordion item,
// with the first item open by default and only one item open at a time. The open
// height is driven by the content's scrollHeight (mirroring accordion.js) because
// an auto-height grid container won't animate 0fr/1fr reliably here. On desktop
// every block is visible, so we clear the accordion state entirely.
export function factsBlocks() {
    const componentSelector = '.facts-blocks';
    const blockSelector = '.facts-block';
    const toggleSelector = '.facts-block__toggle';
    const contentSelector = '.facts-block__content';
    const activeClass = 'facts-block--active';
    const mobileQuery = window.matchMedia('(max-width: 666px)');

    const components = document.querySelectorAll(componentSelector);
    if (!components.length) {
        return;
    }

    const openBlock = (block) => {
        block.classList.add(activeClass);
        const toggle = block.querySelector(toggleSelector);
        const content = block.querySelector(contentSelector);
        if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
        }
        if (content) {
            content.style.maxHeight = `${content.scrollHeight}px`;
        }
    };

    const closeBlock = (block) => {
        block.classList.remove(activeClass);
        const toggle = block.querySelector(toggleSelector);
        const content = block.querySelector(contentSelector);
        if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
        }
        if (content) {
            content.style.maxHeight = '0px';
        }
    };

    // Desktop: content is visible via normal flow, so drop the inline height and
    // the accordion attributes entirely.
    const clearBlock = (block) => {
        block.classList.remove(activeClass);
        const toggle = block.querySelector(toggleSelector);
        const content = block.querySelector(contentSelector);
        if (toggle) {
            toggle.removeAttribute('aria-expanded');
        }
        if (content) {
            content.style.maxHeight = '';
        }
    };

    const allBlocks = [];

    components.forEach(component => {
        const blocks = Array.from(component.querySelectorAll(blockSelector))
            .filter(block => block.querySelector(toggleSelector) && block.querySelector(contentSelector));

        if (!blocks.length) {
            return;
        }

        allBlocks.push(...blocks);

        blocks.forEach(block => {
            const toggle = block.querySelector(toggleSelector);
            toggle.addEventListener('click', () => {
                if (!mobileQuery.matches) {
                    return;
                }
                const isActive = block.classList.contains(activeClass);
                blocks.forEach(closeBlock);
                if (!isActive) {
                    openBlock(block);
                }
            });
        });

        const syncToViewport = () => {
            if (mobileQuery.matches) {
                blocks.forEach((block, index) => (index === 0 ? openBlock(block) : closeBlock(block)));
            } else {
                blocks.forEach(clearBlock);
            }
        };

        syncToViewport();
        mobileQuery.addEventListener('change', syncToViewport);
    });

    // Recompute the open panel's height when the viewport reflows the text.
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            if (!mobileQuery.matches) {
                return;
            }
            allBlocks
                .filter(block => block.classList.contains(activeClass))
                .forEach(block => {
                    const content = block.querySelector(contentSelector);
                    if (content) {
                        content.style.maxHeight = `${content.scrollHeight}px`;
                    }
                });
        }, 50);
    });
}
